export const $as = Symbol('sail.as');
export const $extends = Symbol('sail.extends');
export const $render = Symbol('sail.render');
